/**
 * Link ka OIDC prijavi (eUprava eID) sa pristupačnim screen-reader tekstom.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { APP_PATHS } from '@/shared/constants/routes';

const LoginLaunchLink = ({ children, className = '', title, ...rest }) => (
  <Link
    to={APP_PATHS.AUTH.LOGIN}
    className={className}
    title={title}
    {...rest}
  >
    {children ?? 'Пријави се'}
    <span className="visually-hidden"> преко eUprava eID</span>
  </Link>
);

export default LoginLaunchLink;
